import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useRCAMainStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        marginTop: 64,
        fontFamily: "Source Sans 3",
        backgroundColor: theme.palette.backgrounds.main,
        minHeight: "calc(100vh - 64px)",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 22px",
    },
    contentWrapper: {
        display: "flex",
        padding: 22,
        width: "100%",
        flexDirection: "column",
    },
    contentTitle: {
        fontSize: "24px",
        fontWeight: 400,
        color: theme.palette.text.primary,
        padding: "50px 22px 0px 22px",
    },
    contentHeader: {
        display: "flex",
        justifyContent: "space-between",
    },
    contentHeaderActions: {
        display: "flex",
        alignItems: "flex-end",
        gap: 6,
        padding: "0px 22px",
        marginBottom: 30,
    },
    contentButton: {
        display: "flex",
        gap: 5,
        "&.MuiButton-root": {
            fontFamily: "Source Sans 3 !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            minHeight: `${theme.spacing(10)} !important`,
        },
    },
    contentCard: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    contentTable: {
        "& .MuiTableCell-head": {
            paddingTop: 8,
            paddingBottom: 8,
            color: theme.palette.primary.dark,
            fontWeight: 700,
            fontSize: 12,
            textTransform: "uppercase",
            fontFamily: "Source Sans 3",
            "&>span": {
                color: theme.palette.primary.dark,
            },
            "&>span:hover": {
                color: theme.palette.primary.dark,
                cursor: "default",
            },
        },
    },
    contentTableCell: {
        padding: `8px !important`,
    },
    contentTableExpandedRow: {
        backgroundColor: `${theme.palette.backgrounds.main} !important`,
        "&:hover": {
            backgroundColor: `${theme.palette.backgrounds.main} !important`,
        },
    },
    contentTablePaper: {
        marginTop: 0,
    },
    contentTablePaperMyDashboard: {
        marginTop: 0,
        overflowY: "auto",
        maxHeight: "350px",
    },
    contentForm: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
        justifyContent: "center",
        alignItems: "center",
    },
    contentFormBox: {
        width: "100%",
    },
    contentFormLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
            maxWidth: "200px !important",
            whiteSpace: "normal",
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    contentFormTextField: {
        width: "100%",
        height: theme.spacing(10),
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            backgroundColor: theme.palette.primary.main,
            "& .MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
                padding: `${theme.spacing(2.125)} ${theme.spacing(3.5)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    contentFormTextFieldModal: {
        width: "100%",
        margin: "20px !important",
        paddingRight: "3em !important",
        height: theme.spacing(10),
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            backgroundColor: theme.palette.primary.main,
            "& .MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
                padding: `${theme.spacing(2.125)} ${theme.spacing(3.5)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    contentFormMultitextField: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    contentSelectWithIcon: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: theme.spacing(2),
    },
    contentFormDatePicker: {
        "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-input": {
                padding: `${theme.spacing(3)} ${theme.spacing(5.5)} !important`,
            },
        },
    },
    contentCardHeader: {
        padding: `${theme.spacing(3)} ${theme.spacing(5.5)} !important`,
        display: "flex !important",
        borderBottom: `1px solid ${theme.palette.border.select} !important`,
        justifyContent: "space-between",
        alignItems: "center",
    },
    contentCardTitle: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        color: theme.palette.info.main,
    },
    contentCardTitleCapitalized: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        color: theme.palette.info.main,
        textTransform: "capitalize",
    },
    contentCardActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    contentNoBorderedTextField: {
        "& .MuiInputBase-root": {
            padding: "0 !important",
            fontSize: "14px",
            fontFamily: "Source Sans 3",
            border: "none !important",
            "& .Mui-disabled": {
                color: theme.palette.text.secondary,
                "-webkit-text-fill-color": theme.palette.text.secondary,
            },
            "& fieldset": {
                border: "none !important",
            },
        },
    },
    contentFormHelperText: {
        color: `${theme.palette.error.main} !important`,
    },
    contentToggleButton: {
        minHeight: `${theme.spacing(10)} !important`,

        "& button": {
            fontFamily: "Source Sans 3",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
            padding: `${theme.spacing(1.625)} ${theme.spacing(3)}`,
            transition:
                "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            boxShadow:
                "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
        },
        "& button:hover": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button.Mui-selected": {
            backgroundColor: theme.palette.info.main,
        },
        "& button.Mui-selected:hover": {
            backgroundColor: theme.palette.info.main,
        },
    },
    filtersAppliedHidden: {
        "& button": {
            boxShadow: `0 0 0 2px ${theme.palette.info.main}, 0 4px 8px 0 rgba(0, 0, 0, 0.2)`,
            position: "relative",
        },
        "& button::after": {
            content: '""',
            position: "absolute",
            top: "-4px",
            right: "-4px",
            width: "8px",
            height: "8px",
            backgroundColor: theme.palette.info.main,
            borderRadius: "50%",
            border: `2px solid white`,
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: theme.spacing(0.625),
        },
    },
    contentDateRangePicker: {
        "& > div:first-child": {
            color: theme.palette.text.secondary,
            fontFamily: "Source Sans 3",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.57,
            letterSpacing: "0.00714em",
            marginBottom: 0,
        },
        "& > div > .react-datepicker__input-container": {
            "& > input": {
                backgroundColor: theme.palette.primary.main,
                boxShadow: "none",
                height: theme.spacing(10.25),
                "&::placeholder": {
                    color: theme.palette.text.secondary,
                    fontFamily: "Source Sans 3",
                    fontSize: 14,
                    fontWeight: 400,
                    lineHeight: 1.57,
                    letterSpacing: "0.00714em",
                },
            },
        },
    },
    noOverflow: {
        overflow: "hidden",
    },
    contentNoData: {
        height: "100%",
        width: "100%",
    },
    contentCardContent: {
        padding: `${theme.spacing(2)} !important`,
    },
    contentFormLabelMaxWidth: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
            whiteSpace: "normal",
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    tablesWrapper: {
        display: "flex",
        flexDirection: "row",
        padding: 22,
        width: "100%",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        "& > div": {
            flex: 1,
        },
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: theme.spacing(10),
        },
    },
}));

export const useRCAHistoryMainStyles = makeStyles((theme: Theme) => ({
    avatarWrapper: {
        display: "flex",
        gap: theme.spacing(4),
    },
    nameAndDateWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    avatarName: {
        fontFamily: "Source Sans 3",
        fontSize: "14px",
    },
    avatarDate: {
        fontFamily: "Source Sans 3",
        fontWeight: 400,
        fontSize: "11px",
    },
    historyText: {
        fontFamily: "Source Sans 3",
        fontWeight: 500,
        fontSize: "14px",
    },
    historyChangeWrapper: {
        marginTop: theme.spacing(2),
        display: "flex",
        gap: theme.spacing(2),
        marginLeft: "42px",
        alignItems: "center",
    },
    card: {
        marginTop: `${theme.spacing(6)} !important`,
    },
    cardContent: {
        padding: `${theme.spacing(4)} !important`,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
    cardContentLoading: {
        padding: `${theme.spacing(4)} !important`,
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(4),
    },
}));
